module.exports = __webpack_public_path__ + "img/left.2c34d0fe.png";